import styled from "styled-components";

export const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
